import { z } from 'zod';

export const ExtractorConfigDto = z.object({
  digestMaxLinks: z.number().int().nonnegative(),
  digestMarkers: z.array(z.string()),
  recurringMarkers: z.array(z.string()),
  categoryKeywords: z.record(z.string(), z.array(z.string())),
  updatedAt: z.iso.datetime(),
});
export type ExtractorConfigDto = z.infer<typeof ExtractorConfigDto>;

export const ExtractorConfigUpdateInput = z
  .object({
    digestMaxLinks: z.number().int().min(0).max(100),
    digestMarkers: z.array(z.string().min(1).max(60)).max(50),
    recurringMarkers: z.array(z.string().min(1).max(60)).max(50),
    categoryKeywords: z.record(z.string(), z.array(z.string().min(1).max(60)).max(50)),
  })
  .partial();
export type ExtractorConfigUpdateInput = z.infer<typeof ExtractorConfigUpdateInput>;
